export default __webpack_public_path__ + "static/media/facebook-icon-social.a62c98f3.svg";